import React, { useEffect, useState } from 'react';
import { Section, SectionHeading, PRICE_USD_NEXT } from './Shared';
import { Pricing } from './Pricing';
import { tomos, bonuses } from '../data/packContents';
const LaunchUrgency = () => {
  const [timeLeft, setTimeLeft] = useState({
    h: 1,
    m: 0,
    s: 0
  });
  const spotsTaken = 71;
  useEffect(() => {
    const id = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-135" data-mp="1wtpbbjvdfiof">
      <div className="bg-brand-purpleDark text-brand-goldLight font-mono font-semibold text-2xl md:text-4xl rounded-sm px-4 md:px-6 py-2.5 md:py-3.5 min-w-[64px] md:min-w-[88px] text-center tabular-nums border border-brand-gold/40" data-id="element-136" data-mp="1wqtbtr3vklxv">
        {fmt(value)}
      </div>
      <span className="font-seal text-[9px] md:text-[10px] uppercase tracking-seal text-brand-muted mt-2" data-id="element-137" data-mp="25kbzlm1cepi8">
        {label}
      </span>
    </div>;
  return <div className="max-w-3xl mx-auto mb-14" data-id="element-138" data-mp="2fjjfafvjuw8i">
      <div className="glass-panel gold-frame rounded-sm p-6 md:p-10" data-id="element-139" data-mp="2fii0c0bexpli">
        <p className="font-seal text-[10px] md:text-xs uppercase tracking-seal text-brand-goldDark text-center mb-6" data-id="element-140" data-mp="2khkyd0sz6vjz">
          Precio de lanzamiento — cierra en
        </p>

        <div className="flex items-start justify-center gap-3 md:gap-5 mb-7" data-id="element-141" data-mp="2taoh9ome40m0">
          <TimeBox value={timeLeft.h} label="Horas" data-id="element-142" data-mp="2tcsitzwtgnj4" />
          <span className="text-2xl md:text-3xl text-brand-purpleDark/40 pt-2" data-id="element-143" data-mp="2yau4mslmn0ya">
            :
          </span>
          <TimeBox value={timeLeft.m} label="Minutos" data-id="element-144" data-mp="339nkgrodz41m" />
          <span className="text-2xl md:text-3xl text-brand-purpleDark/40 pt-2" data-id="element-145" data-mp="136cwort1w0x9">
            :
          </span>
          <TimeBox value={timeLeft.s} label="Segundos" data-id="element-146" data-mp="y81m2euxlmdz" />
        </div>

        <p className="text-center text-sm md:text-base text-brand-text/85 border-y border-brand-gold/30 py-3 mb-7" data-id="element-147" data-mp="y5ovxef0s5pu">
          Después el precio sube a {PRICE_USD_NEXT}.{' '}
          <span className="text-brand-burgundy font-semibold" data-id="element-148" data-mp="184ee78atvs6m">No regresa.</span>
        </p>

        <div data-id="element-149" data-mp="1lvj7ztrilq91">
          <div className="flex items-center justify-between gap-3 mb-3" data-id="element-150" data-mp="1lz71iswymcnr">
            <span className="text-sm text-brand-purpleDark font-medium" data-id="element-151" data-mp="1huqxkx6wpfb6">
              Cupos al precio de lanzamiento
            </span>
            <span className="font-seal text-[10px] uppercase tracking-seal text-brand-burgundy" data-id="element-152" data-mp="1vsxo1s9j0d0t">
              Quedan pocos
            </span>
          </div>
          <div className="w-full bg-brand-surfaceLight rounded-full h-1.5 overflow-hidden border border-brand-purpleDark/10" data-id="element-153" data-mp="1i21tn5f4zfk">
            <div className="bg-brand-burgundy h-full rounded-full transition-all duration-1000 ease-out" style={{
            width: `${spotsTaken}%`
          }} data-id="element-154" data-mp="3spocw0ugw46g" />
          </div>
          <p className="text-xs text-brand-muted text-center mt-3" data-id="element-155" data-mp="2d42v4vg7hztk">
            <strong className="text-brand-purpleDark" data-id="element-156" data-mp="1yght74v2i6n8">{spotsTaken}%</strong> de
            los cupos al precio de lanzamiento ya fueron tomados
          </p>
        </div>
      </div>
    </div>;
};
export const PackContents = () => <Section id="method" className="relative" data-id="element-157" data-mp="1pe8m6oz0cvel">
    <SectionHeading eyebrow="El contenido" className="mb-12" data-id="element-158" data-mp="1ue4ngggbm8qg">
      3 tomos principales + 6 bonus estratégicos gratis
    </SectionHeading>

    <p className="text-center text-brand-text/70 text-base md:text-lg -mt-6 mb-12 font-display italic" data-id="element-159" data-mp="1fhx41icqlbc8">
      Más de 190 páginas. Todo resuelto.
    </p>

    <div className="max-w-3xl mx-auto mb-16 space-y-5" data-id="element-160" data-mp="1khrtrikrzuvp">
      {tomos.map(tomo => <article key={tomo.n} className="glass-panel rounded-sm p-5 md:p-7" data-id="element-161" data-mp="39vo9e5o1991v">
          <div className="flex items-start gap-5" data-id="element-162" data-mp="3esok4tvtuzzb">
            <div className="relative w-20 md:w-24 shrink-0 overflow-hidden border border-brand-gold/40" data-id="element-163" data-mp="1erqdx62c857h">
              <img src={tomo.cover} alt={`Tomo ${tomo.n}: ${tomo.title}`} loading="lazy" className="w-full aspect-[3/4] object-cover" data-id="element-164" data-mp="1aqeiul0p2rrw" />
            </div>
            <div className="min-w-0" data-id="element-165" data-mp="15ph3shazedum">
              <span className="block font-seal text-[10px] uppercase tracking-seal text-brand-goldDark mb-2" data-id="element-166" data-mp="10rxl95793ewv">
                Tomo {tomo.n}
              </span>
              <h3 className="font-display font-bold text-lg md:text-2xl leading-tight text-brand-burgundy mb-4" data-id="element-167" data-mp="vu5l5nwgcmhl">
                {tomo.title}
              </h3>
              <ul className="space-y-1.5 text-[13px] md:text-sm text-brand-text/85" data-id="element-168" data-mp="mzr8zu77xs2p">
                {tomo.features.map(f => <li key={f} className="flex items-start gap-2" data-id="element-169" data-mp="i2im5gb4kzv4">
                    <span aria-hidden="true" className="mt-1.5 w-1 h-1 rotate-45 bg-brand-gold shrink-0" data-id="element-170" data-mp="d23d30xvmeiy" />
                    <span data-id="element-171" data-mp="82rs1fqh8mvk">{f}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </article>)}
    </div>

    <div className="text-center mb-8" data-id="element-172" data-mp="3u3xsto6n15z3">
      <p className="font-seal text-[11px] md:text-sm uppercase tracking-seal text-brand-burgundy" data-id="element-173" data-mp="3u73f6vnvttr4">
        6 bonus estratégicos — siempre incluidos
      </p>
    </div>

    <div className="grid grid-cols-3 gap-3 md:gap-5 max-w-3xl mx-auto" data-id="element-174" data-mp="7y288sh7hsty">
      {bonuses.map(bonus => <div key={bonus.n} className="flex flex-col" data-id="element-175" data-mp="cw3s3fmghw6h">
          <div className="relative overflow-hidden border border-brand-gold/40 bg-brand-paper aspect-[3/4]" data-id="element-176" data-mp="3behn8mg3inbt">
            <img src={bonus.cover} alt={`Bonus ${bonus.n}: ${bonus.title}`} loading="lazy" className="absolute inset-0 w-full h-full object-cover" data-id="element-177" data-mp="3gcswow2havti" />
            <span className="absolute top-0 right-0 bg-brand-burgundy text-brand-goldLight font-seal text-[8px] md:text-[10px] uppercase tracking-[0.18em] px-2 py-1" data-id="element-178" data-mp="3lb46j6srx6bq">
              Gratis
            </span>
          </div>
          <p className="text-center text-[10px] md:text-[11px] text-brand-muted mt-2" data-id="element-179" data-mp="2xmuu2vhg9ux9">
            <span className="line-through" data-id="element-180" data-mp="2xki1zphza46h">{bonus.price}</span>
            <span className="ml-1.5 text-brand-goldDark font-semibold" data-id="element-181" data-mp="2pku64m3orva9">
              GRATIS
            </span>
          </p>
        </div>)}
    </div>

    <div className="text-center mt-8" data-id="element-182" data-mp="2zbykbjljfc41">
      <p className="inline-block border border-brand-gold/40 bg-brand-paper px-6 py-3 rounded-sm text-sm md:text-base text-brand-text" data-id="element-183" data-mp="2zawyql6wb782">
        Valor total de los bonus{' '}
        <span className="line-through text-brand-muted" data-id="element-184" data-mp="26mrbnrsdd652">USD 54</span>{' '}
        <span className="text-brand-goldDark font-semibold" data-id="element-185" data-mp="26p41er4dckso">
          incluidos sin costo con tu Mega Pack
        </span>
      </p>
    </div>
  </Section>;
export const MethodOverview = () => <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full" data-id="element-186" data-mp="2gjdxaisis185">
    <LaunchUrgency data-id="element-187" data-mp="2blkrvrz1jb8x" />
    <Pricing data-id="element-188" data-mp="2bl2ng8285qpx" />
  </div>;